<section aria-label="Post-Hearing actions" data-testid="closeout-blockers">
  <ui-grid width="fill" containerClass="no-panel" [rowData]="actions" [columnDefs]="columns()"
    [defaultColDef]="columnDefaults" [agGridOptions]="gridOptions" [showPanelHeader]="false"
    [autoHidePaginator]="true" [rowHeight]="48" noRowsHeight="180px" noDataFoundMessage="No post-hearing actions are available."></ui-grid>
  <div *hearingPhaseBar="'actions'" class="header-actions">
    @for (action of actions; track action.id) { @if (isPrimaryAction(action)) {
      <ui-button severity="primary" [disabled]="busy" (click)="select(action)" [attr.data-action]="action.id">{{ action.actionLabel }} {{ action.label }}</ui-button>
    } }
  </div>
</section>
<ng-template #statusCell let-action><span [attr.data-action]="action.id">{{ action.statusLabel }}</span></ng-template>
<ng-template #actionCell let-action let-params="params">
  @if (!isPrimaryAction(action)) {
    <div class="row-action"><ui-button severity="secondary" size="small" [disabled]="busy" [ariaLabel]="action.actionLabel + ' ' + action.label"
      (focusin)="revealColumn($event, params)" (click)="select(action)">{{ action.actionLabel }}</ui-button></div>
  }
</ng-template>
